<template>
  <v-container>
  <v-layout row wrap justify-center>
    <v-flex sm8 xs12>
      <v-btn class="mx-2"  color="success" @click="copyIds">Copy Ids</v-btn>
      <br>
      <v-text-field v-model="channelName" type='text' name='channel-name' id='channel-name' label='Channel Name' prefix='twitch.tv/' @change='getChannelId' clearable></v-text-field>
      <json-view :data="channel" :maxDepth="5" rootKey="" :styles="style" />
      <json-view :data="duplicates" :maxDepth="5" rootKey="" :styles="style" />
    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
import TwitchWrapper from '@/TwitchWrapper'
import { JSONView } from "vue-json-component";

export default {
  name: 'ListExport',
  components: { "json-view": JSONView },
  data () {
    return {
      response: '',
      isLoaded: false,
      channel: null,
      channels: [],
      user: null,
      channelBadges: null,
      chatBadges: null,
      maxDepth: 1,
      duplicates: '',
      channelName: this.$router.currentRoute.params.channelName,
      comments: '',
      style: {
        key: "#fdf6e3",
        valueKey: "#fdf6e3",
        string: "#cb4b16",
        number: "#d33682",
        boolean: "#268bd2",
        null: "#b58900",
        arrowSize: "6px"
      },
      twitch: new TwitchWrapper(this.$root.$data.clientId),
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    copyIds() {
      //navigator.clipboard.writeText(this.followed.map(f => f.followed_at + ", " + f.display_name).join('\n'))
      navigator.clipboard.writeText(this.channels.map(o => o._id).join('\n'))
    },
    fetchData () {
      this.twitch.GetFile("names.txt").then(names => {
        this.twitch.GetUsersByName(names).then(u => {this.channels = u 
          this.twitch.GetFile("ids.txt").then(ids => {
            this.ids = ids
            this.duplicates = this.channels.filter(c => ids.includes(c._id))
          })
        })
      })
    },
    getChannelId(e) {
      let cn = e.toString().trim()
      if(Number.isInteger(parseInt(cn))) {
        this.twitch.GetChannelById(cn, this.$root.$data.token).then(c => {this.channel = c })
      }
      else {
        this.twitch.GetChannelId(cn).then(u => {
          this.user = u
          this.twitch.GetChannelById(u.users[0]._id, this.$root.$data.token).then(c => {this.channel = c})
        })
      }

    },
  }
}
</script>